import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../services/api.service';
import { AuthService, SessionUser } from '../services/auth.service';
import { ImageService } from '../services/image.service';
import { formatHandicapIndex, parseHandicapIndex } from '../models/handicap';
import { ShellComponent } from '../ui/shell.component';
import { FaceComponent } from '../ui/face.component';

@Component({
  selector: 'app-account',
  standalone: true,
  imports: [FormsModule, ShellComponent, FaceComponent],
  templateUrl: './account.component.html',
})
export class AccountComponent implements OnInit {
  firstName = '';
  lastName = '';
  displayName = '';
  handicapText = '';
  profilePictureUrl = '';
  error = '';
  saved = false;
  uploading = false;

  constructor(private api: ApiService, private auth: AuthService, private images: ImageService) {}

  async ngOnInit(): Promise<void> {
    await this.auth.whenReady();
    const user = this.auth.user();
    if (!user) return;
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.displayName = user.displayName;
    this.handicapText = formatHandicapIndex(user.handicapIndex);
    this.profilePictureUrl = user.profilePictureUrl || '';
  }

  async save(): Promise<void> {
    this.error = '';
    this.saved = false;
    const handicapIndex = parseHandicapIndex(this.handicapText);
    if (handicapIndex == null) {
      this.error = 'Enter a handicap like 10.4 or +1.4';
      return;
    }
    try {
      const result = await this.api.put<{ user: SessionUser }>('user', {
        firstName: this.firstName,
        lastName: this.lastName,
        displayName: this.displayName,
        handicapIndex,
        profilePictureUrl: this.profilePictureUrl,
      });
      this.auth.replaceUser(result.user);
      this.saved = true;
    } catch (error: unknown) {
      this.error = error instanceof Error ? error.message : 'Could not save';
    }
  }

  async onPicture(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';
    if (!file) return;

    this.error = '';
    this.saved = false;
    this.uploading = true;
    try {
      this.profilePictureUrl = await this.images.uploadProfile(file);
      await this.save();
    } catch (error: unknown) {
      this.error = error instanceof Error ? error.message : 'Could not upload the photo';
    } finally {
      this.uploading = false;
    }
  }
}
